import React from "react";
import ExportModal from "../../components/ExportModal";
import {
  buildUserExportFilename,
  buildUserFilterSummary,
  fetchAllUsers,
  USER_EXPORT_COLUMNS,
  USER_EXPORT_TABS,
} from "./userExport";

const ExportUserModal = ({
  activeModal,
  setActiveModal,
  defaultTab = "active",
  searchTerm = "",
  userTypeFilter = "ALL",
  companyFilter = "ALL",
  companies = [],
  pageScope = null,
}) => {
  // The company filter holds an id — resolve the name for the summary and filename.
  const companyName =
    companyFilter !== "ALL"
      ? companies.find((company) => company.id === companyFilter)?.name || ""
      : "";

  return (
    <ExportModal
      activeModal={activeModal}
      setActiveModal={setActiveModal}
      title="Export Users"
      tabs={USER_EXPORT_TABS}
      defaultTab={defaultTab}
      columns={USER_EXPORT_COLUMNS}
      entityLabel={{ one: "user", many: "users" }}
      pageScope={pageScope}
      filterSummary={() =>
        buildUserFilterSummary({ searchTerm, userType: userTypeFilter, companyName })
      }
      fetchRows={({ tab, fromPage, toPage, pageSize, onProgress, isCancelled }) =>
        fetchAllUsers({
          tab,
          searchTerm,
          userType: userTypeFilter,
          company: companyFilter,
          fromPage,
          toPage,
          pageSize,
          onProgress,
          isCancelled,
        })
      }
      buildFilename={(tab, scopeParts) =>
        buildUserExportFilename({
          tab,
          searchTerm,
          userType: userTypeFilter,
          companyName,
          scopeParts,
        })
      }
    />
  );
};

export default ExportUserModal;
